import { css } from '@emotion/react';

export const btnCont1 = css({
    '@media(min-width: 300px)': {
        display: 'flex',
        position: 'relative',
        width: '100%',
        borderRadius: 8,
        paddingTop: 15,
        paddingBottom: 10,
        paddingLeft: 30,
        paddingRight: 30,

        '& .heroArrow': {
            position: 'absolute',
            right: 33,
            top: 16,
            transition: 'right ease 0.5s',
        },

        ':hover': {
            '& .heroArrow': {
                right: 30,
            },
        },

        '& p': {
            fontSize: '2rem',
            fontFamily: 'AcuminRPro',
            margin: 0,
        },
    },

    '@media(min-width: 1200px)': {
        display: 'flex',
        position: 'relative',
        width: 165,
        borderRadius: 8,
        paddingTop: 15,
        paddingBottom: 10,

        '& .heroArrow': {
            position: 'absolute',
            right: 32,
            top: 15,
            transition: 'right ease 0.5s',
        },

        ':hover': {
            '& .heroArrow': {
                right: 26,
            },
        },

        '& p': {
            fontSize: '1.4rem',
            fontFamily: 'AcuminRPro',
            margin: 0,
        },
    },

});

export const heroImage = css({
    '@media(min-width: 300px)': {
        height: '100vh',
        width: '100%',
        objectFit: 'cover',
    },
    '@media(min-width: 992px)': {
        height: '100vh',
        width: '100%',
        objectFit: 'cover',
    },
    '@media(min-width: 1200px)': {
        height: '100%',
        width: '100%',
        objectFit: 'cover',
    },
});

export const heroTextContainer = css({
    '@media(min-width: 300px)': {
        position: 'absolute',
        width: 330,
        bottom: 50,
        marginLeft: 'auto',
        marginRight: 'auto',
        left: 0,
        right: 0,
        paddingBottom: 20,

        '& .heroText': {
            display: 'none',
            textAlign: 'center',
        },

        '& .heroTextMobile': {
            color: 'white',
            fontWeight: 'bold',
            fontSize: '3.8rem',
            textAlign: 'center',
            letterSpacing: 2,
            transform: 'scale(1, 0.9)',
        },
    },
    '@media(min-width: 768px)': {
        position: 'absolute',
        width: '60%',
        bottom: 50,
        marginLeft: 'auto',
        marginRight: 'auto',
        left: 0,
        right: 0,

        '& .heroText': {
            display: 'none',
            textAlign: 'center',
        },

        '& .heroTextMobile': {
            color: 'white',
            fontWeight: 'bold',
            fontSize: '3rem',
            textAlign: 'center',
            letterSpacing: 2,
            transform: 'scale(1, 0.9)',
        },
    },
    '@media(min-width: 1200px)': {
        position: 'absolute',
        bottom: 70,
        left: 70,

        width: 1000,
        marginLeft: 0,
        marginRight: 0,
        right: 0,

        '& .heroTextMobile': {
            display: 'none',
        },

        '& .heroText': {
            display: 'block',
            fontWeight: 'bold',
            color: 'white',
            fontSize: '5rem',
            textAlign: 'left',
            letterSpacing: 2,
            transform: 'scale(1, 0.9)',
        },
    },
});

export const section1 = css({
    '@media(min-width: 300px)': {
        // paddingTop: 60,
        // paddingLeft: 20,
        // paddingRight: 20,
    },
    '@media(min-width: 768px)': {
        // paddingLeft: 20,
        // paddingRight: 20,
    },
    '@media(min-width: 1200px)': {
        paddingTop: 100,
        paddingLeft: 100,
        paddingRight: 100,
    },
});
export const section2 = css({
    '@media(min-width: 300px)': {
        paddingTop: 60,
        // paddingLeft: 20,
        // paddingRight: 20,

        '& .titleContainer': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingBottom: 60,
            paddingLeft: '15px',
            paddingRight: '15px',
        },

        '& .container': {
            display: 'flex',
            flexDirection: 'column',
            gap: 20,
            width: '100%',
            height: '100%',

            '& .leftContainer': {
                height: 300,
                position: 'relative',
                borderRadius: 8,
                overflow: 'hidden',

                '& .imgCont': {
                    width: '100%',
                    height: '100%',
                },
                '& .textContainer': {
                    position: 'absolute',
                    bottom: 30,
                    left: 30,
                },
            },

            '& .rightContainer': {
                display: 'flex',
                flexDirection: 'column',
                height: 'auto',
                justifyContent: 'space-between',
                gap: 20,

                '& .itemCont': {
                    position: 'relative',
                    borderRadius: 8,
                    overflow: 'hidden',
                    width: '100%',
                    height: 300,
                    border: '1px solid #D9D9D9',

                    '& .imgCont': {
                        width: '100%',
                        height: '100%',
                    },

                    '& .textMobile': {
                        display: 'block',
                        position: 'absolute',
                        bottom: 30,
                        left: 30,
                    },
                    '& .textWeb': {
                        display: 'none',
                        position: 'absolute',
                        bottom: 30,
                        left: 30,
                    },
                },
            },
        },
    },
    '@media(min-width: 1200px)': {
        paddingTop: 100,
        paddingLeft: 100,
        paddingRight: 100,

        '& .titleContainer': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingBottom: 60,
            paddingLeft: '15px',
            paddingRight: '15px',
        },

        '& .container': {
            display: 'flex',
            flexDirection: 'row',
            gap: 20,
            width: '100%',
            height: '100%',

            '& .leftContainer': {
                flex: 1,
                height: '100%',
                position: 'relative',
                borderRadius: 8,
                overflow: 'hidden',

                '& .imgCont': {
                    width: '100%',
                    height: '100%',
                },
                '& .textContainer': {
                    position: 'absolute',
                    bottom: 80,
                    left: 80,
                },
            },

            '& .rightContainer': {
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                height: 'auto',
                justifyContent: 'space-between',
                gap: 20,

                '& .itemCont': {
                    position: 'relative',
                    borderRadius: 8,
                    overflow: 'hidden',
                    width: '100%',
                    height: '100%',
                    border: '1px solid #D9D9D9',

                    '& .imgCont': {
                        width: '100%',
                        height: '100%',
                    },

                    '& .textMobile': {
                        display: 'none',
                        position: 'absolute',
                        bottom: 30,
                        left: 30,
                    },
                    '& .textWeb': {
                        display: 'block',
                        position: 'absolute',
                        bottom: 30,
                        left: 30,
                    },
                },
            },
        },
    },
});

export const section3 = css({
    '@media(min-width: 300px)': {
        paddingTop: 80,

        '& div': {
            overflow: 'hidden',
            position: 'relative',

            '& .textContainer': {
                position: 'absolute',
                width: '100%',
                marginLeft: 'auto',
                marginRight: 'auto',
                top: '25%',
                left: 0,
                right: 0,
                color: 'white',

                '& h2': {
                    textAlign: 'center',
                },

                '& p': {
                    textAlign: 'center',
                },

                '& .priceDate': {
                    borderRadius: 20,
                    border: '1px solid #FFEC9F',
                    width: '45%',
                    padding: 6,
                    paddingTop: 10,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginBottom: 0,

                    '& p': {
                        color: '#FFEC9F',
                        textAlign: 'center',
                        margin: 0,
                        fontFamily: 'AcuminRPro',
                        fontSize: '1.6rem',
                    },
                },

                '& .priceText': {
                    width: 'fit-content',
                    marginLeft: 'auto',
                    marginRight: 'auto',

                    '& div': {
                        display: 'flex',
                        '& img': {
                            width: 15,
                            height: 15,
                            marginTop: -2,
                            marginRight: 8,
                        },
                    },
                },
            },
        },
    },

    '@media(min-width: 1200px)': {
        paddingTop: 200,

        '& div': {
            overflow: 'hidden',
            position: 'relative',

            '& .textContainer': {
                position: 'absolute',
                width: '36%',
                marginLeft: 0,
                marginRight: 0,
                top: 170,
                left: 'auto',
                right: 100,
                color: 'white',

                '& h2': {
                    textAlign: 'center',
                },

                '& p': {
                    textAlign: 'center',
                },

                '& .priceDate': {
                    borderRadius: 20,
                    border: '1px solid #FFEC9F',
                    width: '45%',
                    padding: 6,
                    paddingTop: 10,
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginBottom: 0,

                    '& p': {
                        color: '#FFEC9F',
                        textAlign: 'center',
                        margin: 0,
                        fontFamily: 'AcuminRPro',
                        fontSize: '1.6rem',
                    },
                },

                '& .priceText': {
                    width: 'fit-content',
                    marginLeft: 'auto',
                    marginRight: 'auto',

                    '& div': {
                        display: 'flex',
                        '& img': {
                            width: 15,
                            height: 15,
                            marginTop: -2,
                            marginRight: 8,
                        },
                    },
                },
            },
        },
    },
});

export const section4 = css({

    '@media(min-width: 300px)': {
        paddingTop: 100,
        paddingBottom: 100,
        '& div': {
            display: 'flex',
            flexDirection: 'column',
            gap: 60,
            '& div': {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 0,

                '& h1': {
                    fontSize: '3rem',
                    fontWeight: 'bold',
                    paddingBottom: 15,
                    letterSpacing: 2,
                    transform: 'scale(1, 0.9)',
                    color: '#064E72',
                },
                '& img': {
                    width: 100,
                    height: 100,
                },
                '& p': {
                    fontSize: '1.6rem',
                },
            },
        },
    },

    '@media(min-width: 1200px)': {
        paddingTop: 150,
        paddingBottom: 150,
        '& div': {
            display: 'flex',
            justifyContent: 'center',
            columnGap: 200,

            '& div': {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',

                '& img': {
                    width: 100,
                    height: 100,
                },
            },
        },
    },
});
